<template>
  <div class="complete pretandard">
    <div class="complete__header">
      <div class="animation">
        <lottie-player
          :src="completeLottie"
          background="transparent"
          speed="1"
          autoplay
        ></lottie-player>
      </div>
      <div class="complete__msg">주문이 완료되었습니다.</div>
      <div class="complete__msg--sub">
        안전하게 배송해 드릴게요! 감사합니다.
      </div>
    </div>
    <div class="complete__order">
      <div class="complete__description">
        <div>주문정보 ({{ orders.length }})건</div>
        <div class="complete__price">
          <span class="complete__description--title">최종 결제금액</span>
          <span>{{ totalPrice.toLocaleString() }}원</span>
        </div>
      </div>
      <mobile-list
        class="mobile"
        :orders="orders"
        :vehicles="vehicles"
      ></mobile-list>
      <desktop-list
        class="desktop"
        :orders="orders"
        :vehicles="vehicles"
      ></desktop-list>
    </div>
    <div class="path">
      <div
        class="path__btn path__btn--list"
        @click="
          $router.push('/orders/list/my'),
            $store.commit('updateCompleteOrder', [])
        "
      >
        주문내역 이동
      </div>
      <div
        class="path__btn path__btn--add"
        @click="
          $router.push('/orders/form'), $store.commit('updateCompleteOrder', [])
        "
      >
        주문 추가하기
      </div>
    </div>
  </div>
</template>
<script>
import mobileList from "./MobileList/layout.vue";
import desktopList from "./DesktopList/layout.vue";
import completeLottie from "@/assets/img/order/complete_lottie.json";

export default {
  metaInfo: {
    title: "결제완료" // 확이필요
  },
  components: {
    mobileList,
    desktopList
  },
  async created() {
    this.orders = _.cloneDeep(this.$store.getters["returnCompleteOrder"]());
    await this.getTotalPrice();
    const result = await this.$store.dispatch("config/getVehicles");
    this.vehicles = result.vehicle;

    if (this.orders.length < 1) {
      this.$router.push("/orders/list/my");
    }
  },
  data() {
    return {
      orders: [],
      totalPrice: null,
      completeLottie: JSON.stringify(completeLottie),
      vehicles: null
    };
  },
  methods: {
    getTotalPrice() {
      let tPrice = 0;
      for (let i = 0; i < this.orders.length; i += 1) {
        tPrice = this.orders[i].notifiedPrice + tPrice;
      }
      return (this.totalPrice = tPrice);
    }
  },
  destroyed() {
    this.$store.commit("updateCompleteOrder", []);
  }
};
</script>
<style src="./layout.css" scoped></style>
<style src="@/assets/css/newGlobal.css" scoped></style>
